import moment from "moment";
import styled from "styled-components";
import {Tag} from "antd";

export function getUserPromocodesColumns() {

    return [
        {
            title: "Активен от/до",
            dataIndex: "activeFrom",
            key: "activeFrom",
            width: 50,
            sorter: (a, b) => moment(a.activeFrom).valueOf() - moment(b.activeFrom).valueOf(),
            defaultSortOrder: "ascend",
            render: (_, record) => (
                <>
                    <StyledTag
                        color={"default"}
                    >
                        {moment(record.activeFrom).format("DD.MM.YYYY")}
                    </StyledTag>
                    <StyledTag
                        color={"default"}
                    >
                        {moment(record.activeTo).format("DD.MM.YYYY")}
                    </StyledTag>
                </>
            ),

        },
        {
            title: "Название",
            dataIndex: "title",
            key: "title",
            sorter: (a, b) => a.title - b.title
        },
        {
            title: "Описание",
            dataIndex: "description",
            key: "description",

        },
        {
            title: "Отправлено в",
            dataIndex: "sendAt",
            key: "sendAt",
            render: (text) => (
                <span>{moment(text).format("DD.MM.YYYY HH:mm")}</span>
            ),
            sorter: (a, b) => moment(a.sendAt).valueOf() - moment(b.sendAt).valueOf()
        },
        {
            title: "Использован в заказах",
            dataIndex: "orderInnerIds",
            key: "orderInnerIds",
            render: (_, record) => (
                <>
                    {record.orderInnerIds.length > 0
                        ? record.orderInnerIds.map((item) => (
                            <StyledTag
                                color={"purple"}
                            >
                                {item}
                            </StyledTag>
                        )) : (
                            <StyledTag
                                color={"default"}
                            >
                                не использован
                            </StyledTag>
                        )
                    }
                </>
            ),
        },

    ];
}

const StyledTag = styled(Tag)`
  font-weight: 600;
  text-transform: uppercase;
`;